const translations = { selectQuestions: 'Selección de preguntas', question: 'Pregunta', questions: 'Preguntas' }

export default translations
